export default {
  WIDGET_WIDTH: 570,
  WIDGET_HEIGHT: 486,
  WIDGET_MIN_WIDTH: 370,
  WIDGET_MIN_HEIGHT: 300,
  slug: 'ws-html-widget',
};
